import { css } from '@emotion/core'
import { colors, measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const loginContainer = css`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
`

export const loginSection = css`
  width: 90%;
  max-width: 800px;
  ${MQ.LAPTOPS_DESKTOPS} {
    padding-top: ${2 * unit}px;
  }
  ${MQ.TABLETS_HORIZONTAL} {
    height: 100vh;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`
export const formInfo = css`
  text-align: center;
`
export const loginImgBanner = css`
  width: auto;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  ${MQ.TABLETS_HORIZONTAL} {
    display: none;
  }
`

export const mobileView = css`
  display: none;
  background-color: ${colors.grays.gray6};
  margin: 0;
  padding: 0;
  
  ${MQ.TABLETS} {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: hidden;
  }
`

export const desktopView = css`
  display: block;
  
  ${MQ.TABLETS} {
    display: none;
  }
`
